<template>
    <section id="wrapper" class="auth-saas auth-saas--pro">
        <div class="auth-saas__layout auth-saas__layout--split">
            <aside
                class="auth-saas__brand-panel nk-split-stretch toggle-break-lg toggle-slide toggle-slide-right d-none d-lg-flex"
                data-toggle-body="true"
                data-content="athPromo"
                data-toggle-screen="lg"
                data-toggle-overlay="true"
            >
                <div class="auth-saas__brand-atmosphere" aria-hidden="true">
                    <span class="auth-saas__brand-grid"></span>
                    <span class="auth-saas__brand-glow auth-saas__brand-glow--a"></span>
                    <span class="auth-saas__brand-glow auth-saas__brand-glow--b"></span>
                    <span class="auth-saas__brand-beam"></span>
                </div>
                <div class="auth-saas__brand-content">
                    <div class="auth-saas__brand-lockup">
                        <span class="auth-saas__brand-mark" aria-hidden="true">S</span>
                        <div>
                            <p class="auth-saas__brand-wordmark">Sipinor</p>
                            <p class="auth-saas__brand-product">Account recovery</p>
                        </div>
                    </div>
                    <h2 class="auth-saas__brand-headline">Reset links expire quickly. Your session stays protected.</h2>
                    <p class="auth-saas__brand-copy">
                        We never reveal whether an email is registered. Check your inbox and spam folder for the next steps.
                    </p>
                    <ul class="auth-saas__capability-list">
                        <li>
                            <span class="auth-saas__capability-icon" aria-hidden="true">
                                <admin-icon name="lock"></admin-icon>
                            </span>
                            <div>
                                <strong>Use a unique password</strong>
                                <span>Keep admin credentials separate from other accounts</span>
                            </div>
                        </li>
                        <li>
                            <span class="auth-saas__capability-icon" aria-hidden="true">
                                <admin-icon name="shield"></admin-icon>
                            </span>
                            <div>
                                <strong>Enable two-factor auth</strong>
                                <span>Add a second layer after you regain access</span>
                            </div>
                        </li>
                        <li>
                            <span class="auth-saas__capability-icon" aria-hidden="true">
                                <admin-icon name="headset"></admin-icon>
                            </span>
                            <div>
                                <strong>Ask an administrator</strong>
                                <span>Contact support if a reset link has expired</span>
                            </div>
                        </li>
                    </ul>
                </div>
            </aside>

            <div class="auth-saas__form-column auth-saas__form-column--split">
                <div class="absolute-top-right d-lg-none p-3">
                    <a href="#" class="auth-saas__icon-btn toggle" data-target="athPromo" aria-label="About password reset">
                        <admin-icon name="info"></admin-icon>
                    </a>
                </div>
                <div class="auth-saas__form-main">
                    <div class="auth-saas__form-inner auth-saas__form-inner--enter">
                        <div class="auth-saas__mobile-brand d-lg-none">
                            <span class="auth-saas__brand-mark auth-saas__brand-mark--sm" aria-hidden="true">S</span>
                            <span>Sipinor Admin</span>
                        </div>
                        <div class="auth-saas__card">
                            <p class="auth-saas__eyebrow">Account recovery</p>
                            <h1 class="auth-saas__title">{{ trans('passwords.reset_password') }}</h1>
                            <p class="auth-saas__subtitle">Enter the email associated with your admin account. We will send reset instructions if the address exists.</p>
                            <form
                                class="form-validate is-alter"
                                id="passwordform"
                                @submit.prevent="submit"
                                @keydown="passwordForm.errors.clear($event.target.name)"
                            >
                                <div class="form-group">
                                    <label class="auth-saas__label" for="pw-email">Email</label>
                                    <div class="auth-saas__input-wrap">
                                        <admin-icon name="mail" aria-hidden="true"></admin-icon>
                                        <input
                                            id="pw-email"
                                            type="text"
                                            name="email"
                                            class="auth-saas__input"
                                            autocomplete="email"
                                            :placeholder="trans('auth.email')"
                                            v-model="passwordForm.email"
                                        >
                                    </div>
                                    <show-error class="text-danger" :form-name="passwordForm" prop-name="email"></show-error>
                                </div>
                                <div class="form-group mb-0">
                                    <button class="auth-saas__btn" type="submit" :disabled="passwordForm.busy">
                                        <span v-if="passwordForm.busy" class="auth-saas__btn-spinner" aria-hidden="true"></span>
                                        <admin-icon name="send" v-else aria-hidden="true"></admin-icon>
                                        <span>{{ trans('passwords.reset_password') }}</span>
                                    </button>
                                </div>
                            </form>
                            <div class="auth-saas__note">
                                <router-link to="/login">← Back to sign in</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        data() {
            return {
                passwordForm: new Form({
                    email: ''
                })
            }
        },
        mounted(){
            if(!helper.featureAvailable('reset_password')){
                helper.featureNotAvailableMsg();
                return this.$router.push('/home');
            }
        },
        methods: {
            submit(e){
                this.passwordForm.post('/api/auth/password')
                    .then(response =>  {
                        toastr.success(response.message);
                        this.$router.push('/login');
                    }).catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>
